import React from 'react';
import { makeStyles, Box } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  IconedBoxContainer: ({ error }) => ({
    position: 'relative',
    '&:hover': {
      '& .IBIcon path': {
        fill: error ? theme.palette.error.main : theme.palette.primary.main,
      },
    },
  }),
  IBIcon: ({ error, size }) => ({
    position: 'absolute',
    zIndex: 1,
    top: '50%',
    transform: 'translateY(-50%)',
    left: theme.spacing(2),
    width: size || theme.typography.pxToRem(24),
    height: size || theme.typography.pxToRem(24),
    '&  path': {
      transition: 'fill .3s',
      fill: error ? theme.palette.error.main : theme.palette.grey[600],
    },
  }),
}));

const IconedBox = (props) => {
  const {
    children, Icon, classes: styles = {}, ...restOfProps
  } = props;
  const classes = useStyles(props);

  return (
    <Box
      className={clsx(classes.IconedBoxContainer, styles.IconedBoxContainer, 'IconedBoxContainer')}
      {...restOfProps}
    >
      <Icon className={clsx(classes.IBIcon, styles.IBIcon)} />
      {children}
    </Box>
  );
};

export default IconedBox;
